const pushNotifications = {
  'push-notifications-breadcrumbs': 'Push notifications',
  'push-notifications-filter-title': 'Push notifications filter',
  'push-notifications-clone-failed': 'An error occurred while cloning push notification',
  'push-notifications-clone-successfully': 'Push notification was cloned',
  'push-notifications-send-test': 'Send test push-notification',
  'push-notifications-device-token': 'Device Token',
  'push-notifications-send-test-success': 'Test push notification successfully sent',
  'push-notifications-send-test-error': 'An error occurred while sending test push notification',
  'push-notifications-unable-delete': 'Cannot delete push notification because a schedule exists',
  'push-notifications-unable-update': 'Cannot update push notification because a schedule exists',
  'push-notifications-test-publish-note': 'Note: Sending a notification to the device is available once every 10 seconds',
};

export default pushNotifications;
